/**
 * The backend maps the literal string 'undefined' to global scope.
 * See advisor-backend `workspaces.service.ts:470,618,633`.
 *
 * The sentinel originally arrived by accident: the pre-SDK client built its
 * URLs by interpolation, so an absent workspace id coerced to `'undefined'`.
 * The generated SDK's `defaultPathSerializer` instead *skips* undefined path
 * params, leaving the raw `{id}` placeholder in the URL, so the coercion has
 * to be explicit now.
 */
export const GLOBAL_WORKSPACE_ID = 'undefined'

/**
 * Normalizes a workspace id for use as a `path` parameter. The synthetic
 * Global workspace carries no `id`, which must become the sentinel rather
 * than an unsubstituted `{id}` placeholder.
 */
export function toWorkspacePathId(id: string | undefined | null): string {
  return id ?? GLOBAL_WORKSPACE_ID
}
